import { render } from "./TopUpMpaySuccess.vue?vue&type=template&id=9a1b69e4&scoped=true"
import script from "./TopUpMpaySuccess.vue?vue&type=script&lang=js"
export * from "./TopUpMpaySuccess.vue?vue&type=script&lang=js"

import "./TopUpMpaySuccess.vue?vue&type=style&index=0&id=9a1b69e4&scoped=true&lang=scss"

import exportComponent from "/appl/bamboo/bamboo-agent-home-5/xml-data/build-dir/PORTAL-DREITVWEBUI-JOB1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a1b69e4"]])

export default __exports__